import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function Check({ iconClass, width, height }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 448 512"
      className={iconClass}
      width={width}
      height={height}
    >
      <path fill="currentColor" d="M447.9 142.5l-23.2 22L181 395.3l-22 20.8-22-20.8L23.2 287.6 0 265.6l44-46.5 23.2 22L159 328 380.7 118l23.2-22 44 46.5z" />
    </svg>
  );
}
